// Define interfaces for project data structures based on actual API response
export enum PROJECT_TYPE {
  SURVEY = "survey",
  DATA_ONLY = "data-only",
  DASHBOARD = "dashboard",
  DEFAULT = "",
}
export enum PROJECT_FILTER {
  OWNED = "owned",
  MEMBER = "member",
  BOTH = "both",
  ALL = "all",
}

export type ProjectStatus = "DESIGNING" | string // Add other statuses as you discover them

export interface ProjectMetadata {
  Name: string
  Type: PROJECT_TYPE
  Status: ProjectStatus
  Languages: string[]
  Designlanguage: string
  Created_by: string
  Created_at: string
  Folder?: string
}

export type ProjectFolderList = string[]

export interface ProjectData {
  id: string
  name: string
  owner: string
  metadata: ProjectMetadata
  // Client-side only: set on projects from the archived list (the server
  // response has no archived marker).
  archived?: boolean
}
// Interface for create project request body
export interface CreateProjectBody {
  name: string
  goal: string
  type: string
}

// Interface for update project request body
export interface UpdateProjectBody {
  id: string
  name: string
  goal: string
  status: string
  designLanguage: string
  languages: string[]
  type: string
}

// Define specific API response interfaces
export interface ProjectListResponse {
  result: ProjectData[]
}

export interface ArchivedProjectsResponse {
  result: ProjectData[]
}

// Define the expected structure of project details response
export interface GetProjectInfoResponse {
  data: {
    result: {
      id: string
      owner: string
      metadata: {
        Name: string
        Designlanguage: string
        Goal: string
        Languages: string[]
        Status: string
        Type: string
        Created_at: string
        Created_by: string
      }
    }
  } | null
}
